var moment = require( 'moment' );

/**
 * Funzione che trasforma la data dal formato 2017-05-22T10:08:40.019+02:00 nel formato DD-MM-YYYY
 * @param {any} data: stringa nel formato 2017-05-22T10:08:40.019+02:00
 */
export const formatDate = function convertiData( data, formato ) {
    if ( data !== undefined && data.length > 0 ) {
        var nuovaData;
        var anno = data.substring( 0, 4 );
        var mese = data.substring( 5, 7 );
        var giorno = data.substring( 8, 10 );
        if ( formato === 'it' ) {
            nuovaData = giorno + '-' + mese + '-' + anno
        }
        else {
            nuovaData = anno + '-' + mese + '-' + giorno
        }
        return nuovaData
    }
    else {
        return '';
    }
}

/**
 * Funzione che calcola il totale dei Mq Occupati
 * @param {any} oggetto contenente tutti gli oggetti che devono avere il campo mqOccupati
 *              di cui si vuole fare la somma
 */
export const totMqOccupati = function totMqOccupati( object ) {
    if ( object === null || object === undefined || object.length < 1 ) {
        object.mqSuperficieTotale = null;
        return null;
    }
    else {
        // Estraggo i nomi dei singoli oggetti
        let fieldNames = Object.keys( object );

        var totMq = 0;
        for ( let i = 0; i < fieldNames.length - 1; i++ ) {
            if ( object[fieldNames[i]] !== undefined ) {
                if ( object[fieldNames[i]].length > 0 ) {
                    for ( let j = 0; j < object[fieldNames[i]].length; j++ ) {
                        totMq += checkNumber( object[fieldNames[i]][j].mqOccupati);
                    }
                }
                else if ( object[fieldNames[i]].mqOccupati !== null  && object[fieldNames[i]].mqOccupati !== undefined && !isNaN(object[fieldNames[i]].mqOccupati) ) {
                    totMq += checkNumber( object[fieldNames[i]].mqOccupati);
                }
            }
        }
        object.mqSuperficieTotale = checkNumber(totMq);
        return checkNumber(totMq);
    }
}

export const checkLengthNumber = function checkLengthNumber(value, maxlength){
    let val;
    if (value.length>maxlength){
        val = value.substring(0,4);
    }
    else{
        val = value;
    } 
    return checkNumber(val);
}

// FUNZIONE NON UTILIZZATA PERCHè NON SI COMPORTA COME DOVREBBE. La funzione dovrebbe verificare se il valore immesso è nell'intervallo
// [minValue,maxValue], e in caso negativo dare un messaggio di errore all'utente.

export const checkNumberBoundaries = function checkNumberBoundaries(minValue,maxValue,e) {
    console.log("e.target.value = " + e.target.value)
    let value = e.target.value;
    console.log("value = " + value)
    let val;
    // let digitsNumber = Math.log(val) * Math.LOG10E + 1 | 0;
    
    if ( value < minValue ) {
        val = minValue;
    } else if ( value > maxValue ) {
        val = value;
        // val = maxValue;
        e.target.checkValidity(false);
        e.target.setCustomValidity("Inserire un numero compreso tra 0 e 8");
        console.log("Messaggio setCustomValidity")
        console.log(e.target.setCustomValidity)
    } else {
        val = value;
        e.target.setCustomValidity("Inserire un numero compreso tra 0 e 8");
    }

    return val;
}

/**
 * Funzione che controlla se il valore è un numero valido
 * @param {any} value
 */
export const checkNumber = function checkNumber( value ) {
    console.log('value:'+value);
    if ( value === null || value === undefined || value.length < 1 || isNaN(value) || value === 0 || value === "" ) {
        return "";
    }
    else {
        return parseFloat( value, 10 );
    }
}

/**
 * Funzione che controlla se il valore è un booleano
 * @param {any} value
 */
export const checkBool = function checkBool( value ) {
    if ( typeof(value) !== "boolean" ) {
        return false;
    }
    else {
        return value;
    }
}

/**
 * Funzione che controlla se il valore è nullo
 * se è nullo restituisce stringa vuota altrimenti restituisce il valore
 * @param {any} value
 */
export const checkValue = function checkValue( value ) {
    if ( value === null || value === undefined || value === "") {
        return "";
    }
    else {
        return value;
    }
}

/**
 * Funzione che controlla se la data è valida
 * @param {any} date
 */
export const checkDate = function checkDate( date ) {
    if ( moment( date ).isValid() ) {
        return new moment( date );
    }
    else {
        return null;
    }
}

/**
 * Funzione che effettua la codifica dei metadati presenti nel JSON
 * @param {any} value
 * @param {any} type
 */
export const codificaMetadati = function codificaMetadati( value, type ) {

    if ( value === null || value === undefined ) {
        return "";
    }
    else if ( type === "idProvincia" ) {
        if ( value === "Imperia" ) {
            return "8";
        }
        else if ( value === "Savona" ) {
            return "9";
        }
        else if ( value === "Genova" ) {
            return "10";
        }
        else if ( value === "La Spezia" ) {
            return "11";
        }
        else {
            return "";
        }
    }
    // restituisce il numero di stelle
    else if ( type === "idClassificazioneAttr" ) {
        if ( value === "1" ) {
            return "14";
        }
        else if ( value === "2" ) {
            return "15";
        }
        else if ( value === "3" ) {
            return "16";
        }
        else if ( value === "4" ) {
            return "17";
        }
        else if ( value === "5" ) {
            return "18";
        }
    }
    else if ( type === "idCategoria" ) {
        if ( value === "Campeggio" ) {
            return "9";
        }
        else if ( value === "Villaggio Turistico" ) {
            return "16";
        }
        else if ( value === "Parco Vacanza" ) {
            return "64";
        }
        else if ( value === "Ostello" ) {
            return "13";
        }
        else if ( value === "Casa Per Ferie" ) {
            return "11";
        }
    }
}


/**
 * Funzione che effettua la decodifica dei metadati presenti nel JSON
 * @param {any} value
 * @param {any} type
 */
export const decodificaMetadati = function decodificaMetadati( value, type ) {

    if ( value === null || value === undefined ) {
        return "";
    }
    else if ( type === "idProvincia" ) {
        if ( value === "8" ) {
            return "Imperia";
        }
        else if ( value === "9" ) {
            return "Savona";
        }
        else if ( value === "10" ) {
            return "Genova";
        }
        else if ( value === "11" ) {
            return "La Spezia";
        }
        else {
            return "";
        }
    }
    // restituisce il numero di stelle
    else if ( type === "idClassificazioneAttr" ) {
        if ( value === "14" ) {
            return "1";
        }
        else if ( value === "15" ) {
            return "2";
        }
        else if ( value === "16" ) {
            return "3";
        }
        else if ( value === "17" ) {
            return "4";
        }
        else if ( value === "18" ) {
            return "5";
        }
    }
    else if ( type === "idCategoria" ) {
        if ( value === "9" ) {
            return "Campeggio";
        }
        else if ( value === "16" ) {
            return "Villaggio Turistico";
        }
        else if ( value === "64" ) {
            return "Parco Vacanza";
        }
        else if ( value === "13" ) {
            return "Ostello";
        }
        else if ( value === "11" ) {
            return "Casa Per Ferie";
        }
    }
}

/*Funzione che prende in esame i campi di un radioButtonGroup e restituisce il campo impostato a true*/
export const radioButtonTrue = function radioButtonTrue(object) {
    let fieldNames = Object.keys(object);
    for (let i = 0; i < fieldNames.length; i++ ){

        if (object[fieldNames[i]]){
            return fieldNames[i];
        }
    }
}


// WEBPACK FOOTER //
// ./src/Components/Common/Utils.jsx